<div class="login-as-winery-container">

  <mat-toolbar>
    <mat-toolbar-row>
      <h1>{{ 'Dashboard Admin' | translate }}</h1>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <small>{{ 'Change winery and access admin tools' | translate }}</small>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="wrapper-select">
    <!-- Custom winery selector with integrated search -->
    <div class="winery-selector-container" *ngIf="!loadingWineries && !wineriesError">
      <mat-form-field appearance="outline" class="winery-select-field">
        <mat-label>Seleziona una cantina</mat-label>
        <input matInput [matAutocomplete]="auto" [(ngModel)]="selectedWineryName" (input)="onSearchChange()"
          (click)="onInputClick()" placeholder="Cerca e seleziona una cantina..." autocomplete="off">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWinery"
        (optionSelected)="onWineryOptionSelected($event.option.value)" (opened)="onAutocompleteOpened()">
        <mat-option *ngFor="let winery of filteredWineries" [value]="winery">
          <div class="winery-option" (click)="onWineryOptionSelected(winery)">
            <div class="winery-info">
              <span class="winery-name">{{ winery.name }}</span>
              <span class="winery-id">ID: {{ winery.id }}</span>
            </div>
            <button mat-icon-button class="copy-id-btn" (click)="copyWineryId(winery, $event)"
              [wsTooltip]="'Copia ID cantina'">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </mat-option>
      </mat-autocomplete>

      <div class="account-selector-container" *ngIf="selectedWinery && !loadingAccounts && impersonationAccounts.length > 1">
        <mat-form-field appearance="outline" class="account-select-field">
          <mat-label>{{ 'Select user account' | translate }}</mat-label>
          <mat-select [(value)]="selectedAccount" (selectionChange)="onAccountSelected($event.value)">
            <mat-option *ngFor="let account of impersonationAccounts" [value]="account">
              {{ account.name }} ({{ account.email }})<span *ngIf="account.roleNames"> — {{ account.roleNames }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="loadingAccounts" class="loading-message">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Caricamento utenti...</span>
      </div>

      <div *ngIf="accountsError" class="error-message account-error">
        <mat-icon>error</mat-icon>
        <span>{{ accountsError }}</span>
      </div>

      <ws-button (click)="loginAsWineryClicked()" [callToActionType]="'primary'">
        {{ 'Access' | translate }}
      </ws-button>

    </div>

    <!-- Loading state -->
    <div *ngIf="loadingWineries" class="loading-message">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Caricamento cantine...</span>
    </div>

    <!-- Error state -->
    <div *ngIf="wineriesError" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ wineriesError }}</span>
      <button mat-button (click)="retryLoadWineries()">Riprova</button>
      <button *ngIf="wineriesError.includes('Sessione privilegiata')" mat-button (click)="goToLogin()"
        class="admin-login-btn">
        {{ 'Go to login' | translate }}
      </button>
    </div>
  </div>

  <mat-toolbar>
    <mat-toolbar-row>
      <small>{{ 'Admin functionalities' | translate }}</small>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="menu-card-container">
    <div class="menu-list">
      <ws-button (click)="openContactImportAdmin()" [callToActionType]="">
        <i class="icon-import"></i>
        {{ 'Contact Import ADMIN' | translate }}
      </ws-button>

      <ws-button (click)="openHomepageSetting()" [callToActionType]="">
        <i class="icon-dashboard"></i>
        {{ 'Homepage Setting' | translate }}
      </ws-button>

      <ws-button (click)="openTemplatesBase()" [callToActionType]="">
        <i class="icon-envelope"></i>
        {{ 'Templates BASE' | translate }}
      </ws-button>

      <ws-button (click)="openReservationLogs()" [callToActionType]="">
        <mat-icon>bug_report</mat-icon>
        {{ 'Reservation Logs' | translate }}
      </ws-button>

      <ws-button (click)="openNotificationManager()" [callToActionType]="">
        <mat-icon>notifications</mat-icon>
        {{ 'Notification Manager' | translate }}
      </ws-button>

      <ws-button (click)="openNotificationManagerOld()" [callToActionType]="">
        <mat-icon>notifications</mat-icon>
      {{ 'Notification Manager Old' | translate }}
      </ws-button>

      <ws-button (click)="openAvailabilitiesChecker()" [callToActionType]="">
        <mat-icon>search</mat-icon>
        {{ 'Avalaibilities Checker' | translate }}
      </ws-button>

      <ws-button (click)="openResendEmails()" [callToActionType]="">
        <mat-icon>search</mat-icon>
        {{ 'Resend Emails' | translate }}
      </ws-button>

      <ws-button (click)="openBillingTool()" [callToActionType]="">
        <mat-icon>search</mat-icon>
        {{ 'Billing Tool' | translate }}
      </ws-button>
    </div>

  </div>